var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.loading
      ? _c(
          "div",
          { staticClass: "p-5 text-center text-muted" },
          [
            _c("hollow-dots-spinner", {
              attrs: {
                "animation-duration": 1000,
                "dot-size": 10,
                "dots-num": 3,
                color: "#6F787D",
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "mt-3 font-size-08" }, [
              _vm._v("Carregando..."),
            ]),
          ],
          1
        )
      : _vm.erro
      ? _c(
          "div",
          { staticClass: "alert alert-danger", attrs: { role: "alert" } },
          [
            _c("i", {
              staticClass: "fas fa-exclamation-triangle mr-2",
              attrs: { "aria-hidden": "true" },
            }),
            _vm._v("\n        Não foi possível carregar os dados. "),
            _c(
              "button",
              {
                staticClass: "btn btn-sm btn-link p-0 align-baseline",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.carregar()
                  },
                },
              },
              [_vm._v("Tentar novamente")]
            ),
          ]
        )
      : _vm.anexo
      ? _c(
          "div",
          [
            _vm._t("anexo", null, null, {
              anexo: _vm.anexo,
              refresh: _vm.carregar,
            }),
          ],
          2
        )
      : _c(
          "div",
          [_vm._t("default", null, null, { refresh: _vm.carregar })],
          2
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }